import React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';


const NotFound = () => {
  return (
    <Box sx={{ width: '100%' }}>
      <Typography
        component='label'
        sx={{
          fontWeight: '500',
          fontSize: '20px',
          lineHeight: '24px'
        }}
      >
        現在ご利用いただけません。
      </Typography>
    </Box>
  );
}

export default NotFound;
